module.exports = __webpack_public_path__ + "img/new-jf.e59bae57.png";